const AccountPageLangKey = [
	'notification_deleted_accounts_count',
	'notification_deleted_accounts_title',
	'btn_add_new',
	'btn_delete_multiple_items'
] as const

type IAccountPageLangKey = typeof AccountPageLangKey[number]

export type IAccountPageLang = {
	account_page: Record<IAccountPageLangKey, string>
}

const langEntries = AccountPageLangKey.map(
	(key: IAccountPageLangKey) => [key, `account_page.${key}`]
)

const langObj: Record<IAccountPageLangKey, string> = Object.fromEntries(langEntries)

export const ACCOUNT_PAGE_LANG_KEY: IAccountPageLang = {
	account_page: langObj
}
